<template>
	<div v-if="totalSteps && currentStep" class="c-progress-bar" :style="cssVars">
		<label>
			{{ headline }}
			<progress :value="step" :max="totalSteps">{{ percentage }}</progress>
		</label>
	</div>
</template>

<script>
	export default {
		name: 'progress-bar',
		props: {
			headline: {
				type: String,
			},
			totalSteps: {
				type: [ String, Number ],
				required: true,
			},
			currentStep: {
				type: [ String, Number ],
				required: true,
			},
		},
		data() {
			return {
				step: Number(this.currentStep) ? Number(this.currentStep) - 1 : 0,
			}
		},
		computed: {
			percentage() {
				return Math.round(
					(100 * Number(this.step)) / Number(this.totalSteps - 1)
				) + '%';
			},
			cssVars() {
				return {
					'--progress': this.percentage,
				}
			}
		},
		mounted() {
			// Add a short delay for the animation
			setTimeout(() => {
				this.step = this.currentStep;
			}, 500)
		},

		watch: {
			currentStep(newV) {
				this.step = newV
			}
		}
	};
</script>
